import React, {useContext, useEffect, useState} from "react";
import Meta from "./common/Meta";
import ContextSearchNavbar from "./navbars/ContextSearchNavbar";
import DashboardLayout from "./LayoutContainers/DashboardLayout";
import MDBox from "../components/MDBox";
import Grid from "@mui/material/Grid";
import Footer from "./Footer";
import StatisticsCard from "../app/reports/card/StatisticsCard";

import {
  getActiveMembers,
  getCustomers,
  getReportDataLastMonth,
  getReportDataThisMonth,
  getReportDataToday,
} from "./common/api/ReportApi";
import {formatCurrency, formatDateMask} from "./common/Utils";
import {AppContext} from "../lib/AppContext";
import SalesCard from "./reports/card/SalesCard";
import moment from "moment";
import {Card, CardContent, Divider} from "@mui/material";
import {Link} from "react-router-dom";
import {useAccess} from "../lib/AccessProvider";

export default function SalesDashboard(props) {

  const [context, setContext] = useContext(AppContext);

  const [dataTodayReady, setDataTodayReady] = useState(false);
  const [dataThisMonthReady, setDataThisMonthReady] = useState(false);
  const [dataLastMonthReady, setDataLastMonthReady] = useState(false);
  const [reportDataSales, setReportDataSales] = useState();
  const [reportDataMonthlyBilling, setReportDataMonthlyBilling] = useState();
  const [reportDataLastMonthBilling, setReportDataLastMonthBilling] = useState();

  const [reportDataVisits, setReportDataVisits] = useState();
  const [reportDataTodaySales, setReportDataTodaySales] = useState();
  const [reportDataTodayVisits, setReportDataTodayVisits] = useState();

  const [lastMonthSalesData, setLastMonthSalesData] = useState();
  const [activeMembers, setActiveMembers] = useState();
  const [customers, setCustomers] = useState();
  const [newCustomers, setNewCustomers] = useState();
  const [lastMonthCustomers, setLastMonthCustomers] = useState();

  const [customersReady, setCustomersReady] = useState(false);
  const [passMembers, setPassMembers] = useState();
  const [lastMonthVisitsData, setLastMonthVisitsData] = useState();
  const [currentMonthSpecialEventsData, setCurrentMonthSpecialEventsData] = useState();
  const [lastMonthSpecialEventsData, setLastMonthSpecialEventsData] = useState();
  const [todaySpecialEventsData, setTodaySpecialEventsData] = useState();

  const [orgAccess, setOrgAccess] = useState(null);

  const {getAccess} = useAccess();
  useEffect(() => {
    setOrgAccess(getAccess());
  }, []);

  const getSalesData = () => {
    getReportDataToday().then((response) => {
      setReportDataTodaySales(formatCurrency(response?.totalSales));
      setReportDataTodayVisits(response?.totalVisits || 0);
      setTodaySpecialEventsData(response?.specialEvents || 0);
      setDataTodayReady(true);
    });
    getReportDataThisMonth().then((response) => {
      setReportDataSales(formatCurrency(response?.totalSales));
      setReportDataVisits(response?.totalVisits || 0);
      setReportDataMonthlyBilling(formatCurrency(response?.totalBilling));
      setCurrentMonthSpecialEventsData(response?.specialEvents || 0);
      setDataThisMonthReady(true);
    });

    getActiveMembers().then((response) => {
      setActiveMembers(response?.activeMembers || 0);
      setPassMembers(response?.passMembers || 0);
    });

    getCustomers().then((response) => {
      setCustomersReady(true);
      setCustomers(response?.customers || 0);
      setNewCustomers(response?.newCustomers || 0);
      setLastMonthCustomers(response?.lastMonthCustomers || 0);
    });

    getReportDataLastMonth().then((response) => {
      setLastMonthSalesData(formatCurrency(response?.totalSales));
      setLastMonthVisitsData(response?.totalVisits || 0);
      setLastMonthSpecialEventsData(response?.specialEvents || 0);
      setDataLastMonthReady(true);
    });
  }

  useEffect(() => {
    getSalesData();
  }, []);

  const [lastMonthRange, setLastMonthRange] = useState();
  const [currentMonthRange, setCurrentMonthRange] = useState();

  const getLastMonthSalesRange = () => {
    let today = moment();
    let lastMonth = today.subtract(1, 'month');
    let d = new Date(lastMonth);
    return d.getFullYear() + '/' + formatDateMask(d, 'MMM');
  }

  const getCurrentMonthSalesRange = () => {
    const d = new Date();
    return d.getFullYear() + '/' + formatDateMask(d, 'MMM');
  }

  useEffect(() => {
    setLastMonthRange(getLastMonthSalesRange());
    setCurrentMonthRange(getCurrentMonthSalesRange());
  }, [])

  const [month, setMonth] = useState();
  const [year, setYear] = useState();
  useEffect(() => {
    let d = new Date();
    setMonth(formatDateMask(d, "MMM"));
    setYear(formatDateMask(d, "YYYY"));
  }, []);

  return (
    <DashboardLayout>

      <Meta pageTitle={'Sales Dashboard'}/>

      <ContextSearchNavbar title="Sales Dashboard"/>

      <MDBox py={3}>

        <MDBox mb={3}>
          <Grid container spacing={2}>
            <Grid item sm={3}>
              <Card>
                <CardContent>
                  <h5>
                    Insights
                  </h5>
                  <Divider />
                  <p>
                    <Link to={`/birthdays/report/${year}/${month}`}>Birthdays Report</Link>
                  </p>
                  <p>
                    <Link to={"/tags/report/"}>Tags Report</Link>
                  </p>
                  <p>
                    <Link to={"/zipcode/report/"}>Postal Code Report</Link>
                  </p>
                  <p>
                    <Link to={"/refunds/report/"}>Refunds Report</Link>
                  </p>
                  <p>
                    <Link to={"/invoice/report/"}>Open Invoice Report</Link>
                  </p>
                  <p>
                    <Link to={"/checkin/report/"}>Hourly Check-In Report</Link>
                  </p>
                  <p>
                    <Link to={"/partyage/report/"}>Birthday Party Age Report</Link>
                  </p>
                  <p>
                    <Link to={"/winback/report/"}>Fall off Visit Report</Link>
                  </p>
                  <p>
                    <Link to={"/tips/report/"}>Tips Report</Link>
                  </p>

                  {orgAccess?.ready &&
                    <>
                    <Divider />
                      <p>
                        <Link to={"/organization-customers/report/"}>Organization Customers Report</Link>
                      </p>
                    </>
                  }
                  <p>
                    <Link to={"/giftcard/report/"}>Gift Card Report</Link>
                  </p>

                  <p>
                    <Link to={"/giftcardbalance/report/"}>Gift Card Balance Report</Link>
                  </p>

                  <p>
                    <Link to={"/discountcode/report/"}>Discount Code Report</Link>
                  </p>

                  <p>
                    <Link to={"/duplicates/report/"}>Duplicate Users</Link>
                  </p>

                  <p>
                    <Link to={"/email/report/"}>Outbound Emails</Link>
                  </p>

                  <p>
                    <Link to={"/activity/report/"}>Activities</Link>
                  </p>
                </CardContent>
              </Card>
            </Grid>

            <Grid item sm={9}>

              <Grid container spacing={3}>

                <Grid item xs={9} sm={4}>

                  {dataTodayReady &&
                    <>
                      <SalesCard
                        reportBaseUrl={'sales'}
                        title="sales"
                        count={reportDataTodaySales}
                        range={'today'}
                        percentage={{
                          color: "success",
                          label: "Sales Today",
                        }}
                      />

                    </>
                  }

                </Grid>

                <Grid item xs={12} sm={4}>
                  {dataThisMonthReady &&
                    <>
                      <SalesCard
                        reportBaseUrl={'sales'}
                        title="sales"
                        count={reportDataSales}
                        range={currentMonthRange}
                        percentage={{
                          color: "success",
                          label: "Sales This Month",
                        }}
                      />

                    </>
                  }

                </Grid>

                <Grid item xs={12} sm={4}>
                  {dataLastMonthReady &&
                    <>
                      <SalesCard
                        reportBaseUrl={'sales'}
                        title="sales"
                        range={lastMonthRange}
                        count={lastMonthSalesData}
                        percentage={{
                          color: "success",
                          label: "Sales Last Month",
                        }}
                      />
                    </>
                  }
                </Grid>

              </Grid>
              {customersReady &&
                <Grid container spacing={3} pt={2}>
                  <Grid item xs={12} sm={4}>
                    <>
                      <StatisticsCard
                        reportBaseUrl={'customers'}
                        range={currentMonthRange}
                        title="Customers"
                        count={customers}
                        percentage={{
                          color: "success",
                          label: "Active Customers",
                        }}
                      />
                    </>
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <>
                      <StatisticsCard
                        reportBaseUrl={'customers'}
                        range={currentMonthRange}
                        title="New Customers"
                        count={newCustomers}
                        percentage={{
                          color: "success",
                          label: "New Customers This Month",
                        }}
                      />
                    </>
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <>
                      <StatisticsCard
                        reportBaseUrl={'customers'}
                        range={currentMonthRange}
                        title="New Customers"
                        count={lastMonthCustomers}
                        percentage={{
                          color: "success",
                          label: "New Customers Last Month",
                        }}
                      />
                    </>
                  </Grid>

                </Grid>
              }
              <Grid container spacing={3} pt={2}>
                <Grid item xs={12} sm={4}>
                  {dataThisMonthReady &&
                    <>
                      <SalesCard
                        title="Member Billing"
                        count={reportDataMonthlyBilling}
                        range={currentMonthRange}
                        reportBaseUrl={'billing'}
                        percentage={{
                          color: "success",
                          label: "Recurring Membership Billing",
                        }}
                      />
                    </>
                  }
                </Grid>
                <Grid item xs={12} sm={4}>
                  {activeMembers >= 0 &&
                    <>
                      <StatisticsCard
                        reportBaseUrl={'memberships'}
                        range={currentMonthRange}
                        title="Memberships"
                        count={activeMembers}
                        percentage={{
                          color: "success",
                          label: "Active Recurring Memberships",
                        }}
                      />
                    </>
                  }
                </Grid>

                <Grid item xs={12} sm={4}>
                  {passMembers >= 0 &&
                    <>
                      <StatisticsCard
                        reportBaseUrl={'passes'}
                        range={currentMonthRange}
                        title="Active Passes"
                        count={passMembers}
                        percentage={{
                          color: "success",
                          label: "Active Pass Memberships",
                        }}
                      />
                    </>
                  }
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12} sm={4}>
                  {dataTodayReady &&
                    <MDBox mt={2}>
                      <StatisticsCard
                        title="visits"
                        reportBaseUrl={'visits'}
                        count={reportDataTodayVisits}
                        percentage={{
                          color: "success",
                          label: "Visits Today",
                        }}
                      />
                    </MDBox>
                  }
                </Grid>
                <Grid item xs={12} sm={4}>
                  {dataThisMonthReady &&
                    <MDBox mt={2}>
                      <StatisticsCard
                        reportBaseUrl={'visits'}
                        range={currentMonthRange}
                        title="visits"
                        count={reportDataVisits}
                        percentage={{
                          color: "success",
                          label: "Visits This Month",
                        }}
                      />
                    </MDBox>
                  }
                </Grid>
                <Grid item xs={12} sm={4}>
                  {dataLastMonthReady &&
                    <MDBox mt={2}>
                      <StatisticsCard
                        reportBaseUrl={'visits'}
                        range={lastMonthRange}
                        title="visits"
                        count={lastMonthVisitsData}
                        percentage={{
                          color: "success",
                          label: "Visits Last Month",
                        }}
                      />
                    </MDBox>
                  }
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={4}>
                  {dataTodayReady &&
                    <MDBox mt={2}>
                      <StatisticsCard
                        reportBaseUrl={'parties'}
                        range={currentMonthRange}
                        title="parties"
                        count={todaySpecialEventsData}
                        percentage={{
                          color: "success",
                          label: "Parties Today",
                        }}
                      />
                    </MDBox>
                  }
                </Grid>
                <Grid item xs={12} sm={4}>
                  {dataThisMonthReady &&
                    <MDBox mt={2}>
                      <StatisticsCard
                        reportBaseUrl={'parties'}
                        range={currentMonthRange}
                        title="parties"
                        count={currentMonthSpecialEventsData}
                        percentage={{
                          color: "success",
                          label: "Parties This Month",
                        }}
                      />
                    </MDBox>
                  }
                </Grid>
                <Grid item xs={12} sm={4}>
                  {dataLastMonthReady &&
                    <MDBox mt={2}>
                      <StatisticsCard
                        reportBaseUrl={'parties'}
                        range={lastMonthRange}
                        title="parties"
                        count={lastMonthSpecialEventsData}
                        percentage={{
                          color: "success",
                          label: "Parties Last Month",
                        }}
                      />
                    </MDBox>
                  }

                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
      <Footer/>
    </DashboardLayout>
);
}